
  import OrganizationQuestionDialogInListing from '@/components/OrganizationQuestionDialogInListing';
  import OrganizationListingFilter from '@/components/elements/OrganizationListingFilter';
  import NoDataToShow from '@/components/elements/NoDataToShow';
  import EventBus from '@/events/EventBus';
  import Events from '@/events/Events';
  import {saveNewSearch} from '@/helper/LastSearchesHelper';
  import {
    createObjectFromQuery,
    createObjectFromUrlSearchParams,
    createUrlSearchParamsFromObject,
    createObjectFromQueryString,
  } from '@/helper/QueryHelper';

  export default {
    name: 'OrganizationListingWithFilter',
    components: {
      OrganizationQuestionDialogInListing,
      NoDataToShow,
      OrganizationListingFilter,
      OrganizationListingFilterDialog: () =>
        import('@/components/filter-dialogs/OrganizationListingFilterDialog'),
      Pagination: () => import('@/components/Pagination'),
      OrganizationCard: () => import('@/components/OrganizationCard'),
      RichText: () => import('@/components/elements/RichText'),
      CustomBigTitle: () => import('@/components/CustomBigTitle'),
    },
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data() {
      return {
        newSearchArray: [],
        loading: true,
        organizations: [],
        page: 1,
        countPages: 0,
        itemsPerPage: 16,
        organizationsCount: 0,
        filterParams: '',
        facets: undefined,
        orderBy: {},
        orderByDefault: {key: 'num_open_jobs', direction: 'desc'},
        orderByItems: [
          {
            value: {key: 'num_open_jobs', direction: 'desc'},
            text: this.$t('orderBy.open_jobs.desc'),
          },
          {
            value: {key: 'num_open_jobs', direction: 'asc'},
            text: this.$t('orderBy.open_jobs.asc'),
          },
          {
            value: {key: 'rating', direction: 'desc'},
            text: this.$t('orderBy.rating.desc'),
          },
          {
            value: {key: 'rating', direction: 'asc'},
            text: this.$t('orderBy.rating.asc'),
          },
        ],
        title: '',
      };
    },
    async fetch() {
      this.parseOrderAndPageFromQuery();
      this.generateFilterParamsFromQuery();
      await this.fetchOrganizations();
      this.prepareTitle();
    },
    head() {
      const head = {meta: []};
      const query = Object.assign({}, this.$route.query);
      const canonical_links = [];

      canonical_links.push({
        rel: 'canonical',
        hid: 'canonical',
        href:
          process.env.NUXT_ENV_BASE_URL +
          this.localePath({
            query: {page: this.page > 1 ? this.page : undefined},
          }),
      });

      if (this.page > 1) {
        query.page = this.page - 1;
        canonical_links.push({
          rel: 'prev',
          hid: 'prev',
          href:
            process.env.NUXT_ENV_BASE_URL +
            this.localePath({
              query: query,
            }),
        });
      }

      if (this.page < this.countPages) {
        query.page = this.page + 1;
        canonical_links.push({
          rel: 'next',
          hid: 'next',
          href:
            process.env.NUXT_ENV_BASE_URL +
            this.localePath({
              query: query,
            }),
        });
      }

      head.link = canonical_links;

      if (this.$route.query.user_search || this.page > 1) {
        head.meta.push({
          name: 'robots',
          content: 'noindex',
        });
        head.meta.push({
          name: 'googlebot',
          content: 'noindex',
        });
      }

      return head;
    },
    computed: {
      currentAge() {
        const today = new Date();
        const birthDate = new Date(this.$auth.user.candidateProfile.birthDate);
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age;
      },
      filterParamsObjectFromSection() {
        const filterParams = {};
        if (this.section.filterParams && this.section.filterParams.search) {
          filterParams.search = this.section.filterParams.search;
        }
        if (this.section.filterParams && this.section.filterParams.activities) {
          filterParams['activities'] = this.section.filterParams.activities
            .split(',')
            .map((value) => value.trim());
        }
        return filterParams;
      },
      forcedFilterParams() {
        const forcedFilterParams = new URLSearchParams();
        if (this.section.filterParams && this.section.filterParams.tags) {
          this.section.filterParams.tags.split(',').forEach((value) => {
            forcedFilterParams.append('tagsOr[]', value.trim());
          });
        }
        return forcedFilterParams.toString();
      },
      fullFilterParams() {
        const filterParamsObject = new URLSearchParams(this.filterParams);
        const glue =
          filterParamsObject.toString() !== '' && this.forcedFilterParams !== ''
            ? '&'
            : '';
        return filterParamsObject.toString() + glue + this.forcedFilterParams;
      },
    },
    watch: {
      '$route.query': function () {
        const pageBefore = this.page;
        const filterParamsBefore = this.filterParams;

        this.parseOrderAndPageFromQuery();
        this.generateFilterParamsFromQuery();

        if (
          pageBefore !== this.page ||
          filterParamsBefore !== this.filterParams
        ) {
          this.fetchOrganizations();
        }
      },
      organizationsCount: function () {
        this.prepareTitle();
      },
      organizations: function () {
        this.emitOrganizationListingView();
      },
    },
    created() {
      if (process.client) {
        EventBus.$on('login', this.fetchOrganizations);
        EventBus.$on('logout', this.fetchOrganizations);
      }
    },
    updated() {
      const filterBar = document.querySelector('#pb-filter-bar>div');
      const mainTitle = document.querySelector(
        '#pb-organizationlisting-main-title'
      );
      if (
        mainTitle &&
        filterBar &&
        mainTitle.getBoundingClientRect().height >
          filterBar.getBoundingClientRect().height + 100
      ) {
        document.getElementById('pb-inside-div').style.position = 'absolute';
        document.getElementById('pb-inside-div').style.left = '0px';
        document.getElementById('pb-inside-div').style.width = '100%';
        document.getElementById('pb-inside-div').style.padding = 'inherit';
      } else {
        document.getElementById('pb-inside-div').style.position = 'relative';
        document.getElementById('pb-inside-div').style.padding = 'initial';
      }
    },
    mounted() {
      const filterBarContainer = document.querySelector('#pb-filter-bar');
      const filterBar = document.querySelector('#pb-filter-bar>div');
      let timeout;
      this.handleScroll = () => {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(function () {
          const vh = document.documentElement.clientHeight;
          const boundingRect = filterBar.getBoundingClientRect();
          if (boundingRect.bottom < vh) {
            const currentTop = parseInt(filterBar.style.top, 10);
            filterBar.style.top =
              currentTop + (vh - boundingRect.bottom) + 'px';
          }
          if (boundingRect.top - vh > -vh) {
            const currentTop = parseInt(filterBar.style.top, 10);
            filterBar.style.top = currentTop - boundingRect.top + 100 + 'px';
          }
          const newTop = parseInt(filterBar.style.top, 10);
          const clamp = (num, min, max) => Math.min(Math.max(num, min), max);
          filterBar.style.top =
            clamp(
              newTop,
              0,
              filterBarContainer.getBoundingClientRect().height -
                boundingRect.height
            ) + 'px';
        }, 100);
      };
      if (filterBarContainer && filterBar) {
        document.addEventListener('scroll', this.handleScroll);
      }
    },
    destroyed() {
      if (process.client) {
        EventBus.$off('login', this.fetchOrganizations);
        EventBus.$off('logout');
        if (this.handleScroll) {
          document.removeEventListener('scroll', this.handleScroll);
        }
      }
    },
    methods: {
      parseOrderAndPageFromQuery() {
        this.page = this.$route.query.page
          ? parseInt(this.$route.query.page)
          : 1;
        const foundOrder = Object.keys(this.$route.query).find((k) =>
          k.includes('order[')
        );
        if (foundOrder) {
          const order = foundOrder.match(/^order\[(.+)\]$/)[1];
          this.orderBy = {
            key: order,
            direction: this.$route.query[foundOrder],
          };
        } else {
          this.orderBy = {...this.orderByDefault};
        }
      },
      generateFilterParamsFromQuery() {
        const filterParams = this.$route.query.user_search
          ? {}
          : {...this.filterParamsObjectFromSection};

        const queryParams = createObjectFromQuery(this.$route.query);
        for (const key in queryParams) {
          if (!Object.prototype.hasOwnProperty.call(queryParams, key)) {
            continue;
          }
          if (key === 'page' || key.includes('order[')) {
            continue;
          }
          filterParams[key] = queryParams[key];
        }
        const urlSearchParams = createUrlSearchParamsFromObject(filterParams);
        urlSearchParams.sort();
        this.filterParams = urlSearchParams.toString();
      },
      convertFilterParamsToTypesense(fullFilterParams) {
        fullFilterParams = new URLSearchParams(fullFilterParams);

        function addFilterBy(key, value) {
          convertedParameters.set(
            'filter_by',
            (convertedParameters.has('filter_by')
              ? convertedParameters.get('filter_by') + ' && '
              : '') +
              key +
              ':=' +
              '[' +
              value.join(',') +
              ']'
          );
        }

        function addFilterByOpenJobs(value) {
          const operator = value === '1' ? ':>' : ':=';
          convertedParameters.set(
            'filter_by',
            (convertedParameters.has('filter_by')
              ? convertedParameters.get('filter_by') + ' && '
              : '') +
              'openJobs' +
              operator +
              0
          );
        }

        const convertedParameters = new URLSearchParams();
        convertedParameters.set('q', '*');
        if (fullFilterParams.has('search'))
          convertedParameters.set('q', fullFilterParams.get('search'));

        if (fullFilterParams.has('activity[]')) {
          const activities = [];
          fullFilterParams.getAll('activity[]').map((activity) => {
            const decodedString = decodeURI(activity.toString());
            const regex = /[([\])]/g;
            activities.push(decodedString.replace(regex, ''));
          });
          addFilterBy('activities', activities);
        }

        if (fullFilterParams.has('industry[]')) {
          const industries = [];
          fullFilterParams.getAll('industry[]').map((industry) => {
            const decodedString = decodeURI(industry.toString());
            const regex = /[([\])]/g;
            industries.push(decodedString.replace(regex, ''));
          });
          addFilterBy('industries', industries);
        }

        if (fullFilterParams.has('openJobs')) {
          addFilterByOpenJobs(fullFilterParams.get('openJobs'));
        }
        return convertedParameters;
      },
      async fetchOrganizations() {
        const getParameters = new URLSearchParams();
        getParameters.set('query_by', 'name,city,short_description');
        getParameters.set('query_by_weights', '4,3,1');
        getParameters.set('include_fields', 'id');

        const fullFilterParams = new URLSearchParams(this.fullFilterParams);
        const postParameters =
          this.convertFilterParamsToTypesense(fullFilterParams);

        postParameters.set('collection', 'organization');
        postParameters.set('per_page', this.itemsPerPage);
        postParameters.set('page', this.page);
        postParameters.set('max_facet_values', '100');
        postParameters.set('facet_by', 'activities,industries');
        const orderByMapping = {
          num_open_jobs: 'openJobs',
          rating: 'times_rated',
        };
        postParameters.set(
          'sort_by',
          `${orderByMapping[this.orderBy.key]}(missing_values: last):${
            this.orderBy.direction
          },name:asc`
        );

        const searches = [postParameters];

        let activityFacetIndex = 0;
        if (fullFilterParams.has('activity[]')) {
          const activityFacetParameters = new URLSearchParams(fullFilterParams);
          activityFacetParameters.delete('activity[]');
          const convertedActivityParameters =
            this.convertFilterParamsToTypesense(activityFacetParameters);
          convertedActivityParameters.set('collection', 'organization');
          convertedActivityParameters.set('per_page', '0');
          convertedActivityParameters.set('page', '1');
          convertedActivityParameters.set('max_facet_values', '100');
          convertedActivityParameters.set('facet_by', 'activities,industries');
          searches.push(convertedActivityParameters);
          activityFacetIndex = searches.length - 1;
        }

        let industryFacetIndex = 0;
        if (fullFilterParams.has('industry[]')) {
          const industriesFacetParameters = new URLSearchParams(
            fullFilterParams
          );
          industriesFacetParameters.delete('industry[]');
          const convertedIndustriesParameters =
            this.convertFilterParamsToTypesense(industriesFacetParameters);
          convertedIndustriesParameters.set('collection', 'organization');
          convertedIndustriesParameters.set('per_page', '0');
          convertedIndustriesParameters.set('page', '1');
          convertedIndustriesParameters.set('max_facet_values', '100');
          convertedIndustriesParameters.set(
            'facet_by',
            'activities,industries'
          );
          searches.push(convertedIndustriesParameters);
          industryFacetIndex = searches.length - 1;
        }

        const typesenseSearches = searches.map((search) =>
          Object.fromEntries(search)
        );

        if (process.client) {
          await this.$localforage.setItem(
            'TypesenseParams',
            typesenseSearches[0]
          );
        }

        const results = (
          await this.$store.dispatch(
            'api/organization/getOrganizationsFromTypesenseMultisearch',
            {
              getParameters,
              searches: typesenseSearches,
            }
          )
        ).results;

        let error = false;
        results.forEach((result) => {
          if (result.code) error = true;
        });
        const organizationResponse = results[0];

        if (!error) {
          this.organizationsCount = organizationResponse.found;
          this.countPages = Math.ceil(
            organizationResponse.found / this.itemsPerPage
          );
          this.facets = {
            activities: results[activityFacetIndex].facet_counts[0].counts,
            industries: results[industryFacetIndex].facet_counts[1].counts,
          };
        } else {
          this.organizationsCount = 0;
          this.countPages = 0;
        }

        let orderedOrganizations = [];
        if (this.organizationsCount > 0) {
          const apiGetParameters = new URLSearchParams();
          const idsToGet = [];
          const addHitToIdArray = (item) => {
            if (idsToGet.indexOf(item.document.id) === -1)
              idsToGet.push(item.document.id);
          };
          organizationResponse.hits.forEach(addHitToIdArray);
          idsToGet.forEach((id) => apiGetParameters.append('id[]', id));

          const organizations = (
            await this.$store.dispatch(
              'api/organization/getOrganizationCards',
              apiGetParameters
            )
          ).data;

          const findOrganizationById = (id) => {
            let foundOrganization;
            for (const organization of organizations) {
              if (organization.id === id) {
                foundOrganization = organization;
                break;
              }
            }
            return foundOrganization;
          };

          const orderOrganizations = (hits) => {
            const orderedOrganizations = [];
            for (let i = 0; i < hits.length; i++) {
              const foundOrganization = findOrganizationById(
                hits[i].document.id
              );
              if (foundOrganization)
                orderedOrganizations[i] = foundOrganization;
            }
            return orderedOrganizations;
          };

          orderedOrganizations = orderOrganizations(organizationResponse.hits);
        }

        this.organizations = orderedOrganizations.filter((element) => {
          if (Object.keys(element).length !== 0) {
            return true;
          }
          return false;
        });
        this.loading = false;
      },
      pushRouterAndFetchOrganizations() {
        this.pushRouter();
        this.fetchOrganizations();
      },
      setFilterParamsAndResetOrderAndPage(params) {
        this.page = 1;
        params.set('user_search', '1');
        this.setFilterParams(params, true);
        this.$emitWithClientData(Events.OrganizationsSearched, {
          filterParams: createObjectFromUrlSearchParams(params),
        });
      },
      resetFilterParams() {
        this.page = 1;
        const params = createUrlSearchParamsFromObject({
          ...this.filterParamsObjectFromSection,
        });
        params.set('user_search', '1');
        this.setFilterParams(params, true);
      },
      setFilterParams(params, force) {
        params.sort();
        if (!force && params.toString() === this.filterParams) {
          return;
        }

        this.filterParams = params.toString();
        this.pushRouterAndFetchOrganizations();
      },
      async pushRouter() {
        const filterValues = createObjectFromQueryString(this.filterParams);
        if (
          filterValues.search ||
          filterValues['activity[]'] ||
          filterValues['industry[]']
        ) {
          const url =
            this.localePath({}) +
            `?${this.filterParams}` +
            `&order[${this.orderBy.key}]=${this.orderBy.direction}` +
            `&page=1`;
          const newSearch = {
            page: this.$route.path,
            url: url,
            what: filterValues.search || '',
            where: '',
            activities: filterValues['activity[]'] || [],
            branches: filterValues['industry[]'] || [],
            employmentTypesOr: [],
          };
          this.newSearchArray = saveNewSearch(
            newSearch,
            await this.$localforage.getItem('SavedSearches')
          );
          await this.$localforage.setItem('SavedSearches', this.newSearchArray);
        }
        this.$router.push(
          this.localePath({}) +
            `?${this.filterParams}` +
            `&order[${this.orderBy.key}]=${this.orderBy.direction}` +
            `&page=${this.page}`
        );
      },
      prepareTitle() {
        this.title = this.section.title
          ? this.section.title.replace(
              '%num_organizations',
              this.organizationsCount
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            )
          : '';
      },
      emitOrganizationListingView() {
        const items = this.organizations.map((item, key) => {
          const position = key + 1;
          return {
            id: item.id,
            position,
          };
        });

        this.$emitWithClientData(Events.OrganizationListingViewed, {
          itemsPerPage: this.itemsPerPage,
          items,
          page: this.page,
        });
      },
      refetchOrganization(organizationId) {
        const organizationPosition = this.organizations.findIndex(
          (item) => item.id === organizationId
        );
        if (organizationPosition > -1) {
          this.$store
            .dispatch('api/organization/getOrganizationCard', organizationId)
            .then((organization) => {
              this.organizations = Array.from(this.organizations);
              this.organizations[organizationPosition] = organization;
            });
        }
      },
    },
  };
